/**
 * API 베이스 URL.
 *
 * - 빈 값(기본): **같은 오리진**을 사용한다. dev 는 vite 프록시(`vite.config.ts`),
 *   prod 는 FastAPI 가 `web/dist` 를 서빙하는 경우에 해당 → CORS 설정이 필요 없다.
 * - 절대 URL(`http://192.168.0.10:8000`): 백엔드가 다른 오리진일 때 사용
 *   → 백엔드 `CORS_ORIGINS` 에 이 앱의 오리진을 허용해야 한다.
 */
export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL ?? "").replace(
  /\/+$/,
  "",
);

/** 탭이 보이는 동안 목록을 자동 재조회하는 주기(모니터링 앱이라 기본 활성). */
export const AUTO_REFRESH_MS = 60_000;

/**
 * 종목 등록 직후 재조회 정책.
 *
 * 서버는 등록 응답을 먼저 돌려주고 KIS 시세를 백그라운드로 채운다
 * (`server/app/api/routes_tickers.py` 의 `register_ticker`). 그 사이 목록의 RSI 는
 * 비어 있으므로 채워질 때까지 짧게 재조회한다. 폐지·오타 심볼이면 끝내 안 채워지니
 * 시도 횟수를 제한한다.
 */
export const REGISTER_POLL_MS = 2_000;
export const REGISTER_POLL_TRIES = 6;
